import {useCallback, useState} from "react";
import BillingSetting from "./billing-setting";

export function useBillingSetting() {
    const [loading, setLoading] = useState(false);

    const getBillingSettings = useCallback(async () => {
        const billingSetting = new BillingSetting();
        setLoading(true);
        try {
            const data = await billingSetting.getAll({populate: "*"});
            return data.data;
        } catch (error) {
            if (error?.status === 404) return null;
            throw error;
        } finally {
            setLoading(false);
        }
    }, []);

    return {getBillingSettings, loading};
}
